/**
 * Dialog wrapper around <ForgettingCurveChart>. Opens when a TroubleCard is
 * tapped from the dashboard widget so the student can see why a card is hard.
 */
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import ForgettingCurveChart from "./ForgettingCurveChart";

export default function ForgettingCurveDialog({ questionId, open, onClose }) {
  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose?.()}>
      <DialogContent className="max-w-md" data-testid="forgetting-curve-dialog">
        <DialogHeader>
          <DialogTitle className="font-display text-base">Predicted Forgetting Curve</DialogTitle>
          <DialogDescription className="text-xs">
            How likely you are to recall this card over the next 90 days, based on
            your review history. The yellow band is the FSRS sweet spot — review
            then for max efficiency.
          </DialogDescription>
        </DialogHeader>
        {questionId && <ForgettingCurveChart questionId={questionId} height={140} horizonDays={90} />}
      </DialogContent>
    </Dialog>
  );
}
